// extracted by mini-css-extract-plugin
module.exports = {"tile":"Game_tile__3CgbQ","gameTiles":"Game_gameTiles__M5Xj1"};